module.exports = __webpack_public_path__ + "img/test-upload-img.fa5ab50c.png";